import { httpGet, httpPost } from "@/api/connection";

const storeFprSettings = async (values) => {
  return await httpPost("/integrations/fpr/settings", values);
};

const getFprSettings = async () => {
  return await httpGet("/integrations/fpr/settings");
};

const getCaseTypesWithFpr = async () => {
  return await httpGet("/integrations/fpr/options");
};

const markItemsAsReported = async (evidenceIDs) => {
  return await httpPost("/integrations/fpr/mark-as-reported", {
    evidence_ids: evidenceIDs,
  });
};

export const FprAPI = {
  storeFprSettings,
  getFprSettings,
  getCaseTypesWithFpr,
  markItemsAsReported,
};
